class HttpResponseCodeService {
  constructor () {
    this.responseCodeMessages = {
      400: 'Error 400: The Agent Portal has made an invalid request.',
      401: 'Error 401: You are not authorized, please try logging out and logging in to the Agent Portal to refresh your login. If this issue persists, please contact HawkSoft Support.',
      403: 'Error 403: You are not authorized to access this section of the Agent Portal. Please try logging out and logging in, and try again. If the issue persists, contact your manager to ensure you have permissions.',
      404: 'Error 404: We were unable to complete the request because the requested service is unavailable. Please try again, or contact HawkSoft Support.',
      500: 'Error 500: The Agent Portal has encountered a critical error. Please try again, or contact HawkSoft Support.',
      503: 'Error 503: The Agent Portal is not currently available. Please try again in 5 to 10 minutes.'
    };
  }

  getResponseCodeMessage (code) {
    if (code < 400) {
      return '';
    }

    if (code > 404 && code < 500) {
      return `The Agent Portal website has encountered an unknown error. Please try again. ${code}`;
    }

    if (code > 503) {
      return `The Agent Portal server has encountered an unknown error. Please try again. ${code}`;
    }

    var msg = this.responseCodeMessages[code];

    if ((msg || null) === null) {
      return 'The Agent Portal has encounted an unknown error. Please try again, or contact HawkSoft Support';
    }

    return msg;
  }
}

var x = new HttpResponseCodeService();
export default x;
